import { getHostsSelectors, hostsSliceActions } from '@/modules/host/slice';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { RootState } from '@/store/store';
import { Epic } from 'redux-observable';
import { concat, filter, switchMap } from 'rxjs';

export const hostInitEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(hostsSliceActions.gameInit.match),
        switchMap(action => {
            console.log(`update order`, action.payload);
            const outs = [];
            const state = store$.value as unknown as RootState;
            const hosts = getHostsSelectors.selectAll(state);
            let openHosts = [] as number[];
            hosts.forEach(v => {
                if (!v.IsRest) {
                    openHosts.push(v.HostId);
                }
            });

            outs.push(LiveDataSliceActions.updateOpenTable(openHosts));
            return concat(outs);
        })
    );

// export const hostInitEpic: Epic = (action$, store$) =>
//     action$.pipe(
//         filter(hostsSliceActions.gameInit.match),
//         switchMap(action => {
//             console.log(`update order ${action.payload}`);
//             const outs = [];
//             const state = store$.value as unknown as RootState;
//             const hosts = getHostsSelectors.selectAll(state);
//             const { FeatureOrder } = getMainUserState(state);
//             const fullHostList = hosts.sort((a, b) => {
//                 let orderA = 10000;
//                 let orderB = 10000;
//                 if (a.IsTest) {
//                     orderA = 20000;
//                 }
//                 if (b.IsTest) {
//                     orderB = 20000;
//                 }
//                 if (FeatureOrder) {
//                     if (FeatureOrder.indexOf(a.GameType) >= 0) {
//                         orderA += FeatureOrder.indexOf(a.GameType) * 100;
//                     }
//                     if (FeatureOrder.indexOf(b.GameType) >= 0) {
//                         orderB += FeatureOrder.indexOf(b.GameType) * 100;
//                     }
//                 }
//                 return a.OrderBy + orderA - (b.OrderBy + orderB);
//             });
//             let openHosts = [] as HostTable[];
//             let closeHosts = [] as HostTable[];
//             fullHostList.forEach(v => {
//                 if (v.IsRest) {
//                     closeHosts.push(v);
//                 } else {
//                     openHosts.push(v);
//                 }
//             });

//             const hallGameTypeMap = openHosts.concat(closeHosts).map(h => ({
//                 hostId: h.HostId,
//                 hallId: h.HallId,
//                 gameType: h.GameType,
//             }));
//             outs.push(lobbySliceActions.updateHallGameTypeMap(hallGameTypeMap));
//             return concat(outs);
//         })
//     );
